module.exports = __webpack_public_path__ + "img/nav_icon_expedite.29d73c64.svg";